import React from "react";
import { useGlobalContext } from "../context";
import Loading from "./Loading";
import Cocktail from "./Cocktail";
import FavoriteCocktails from "./FavoriteCocktails";

const CocktailList = () => {
  const { cocktails, tempCocktails, loading } = useGlobalContext();

  const getLocalStorage = () => {
    let cocktails = localStorage.getItem("favorites");
    if (cocktails) {
      return (cocktails = JSON.parse(localStorage.getItem("favorites")));
    } else {
      return [];
    }
  };

  if (loading) {
    return <Loading />;
  }
  if (tempCocktails.length < 1) {
    return (
      <div className="cocktailList">
        <h1 className="title">Cocktails</h1>
        <h2 className="noMatch">No cocktails matched your search criteria!</h2>
      </div>
    );
  }

  return (
    <div className="cocktailList">
      <h1 className="title">Cocktails</h1>
      <div className="cocktails">
        {tempCocktails.map((item, i) => {
          const favorites = getLocalStorage();

          if (favorites.length > 0) {
            const favIndex = favorites.findIndex((object) => {
              return object.id === item.id;
            });
            if (favIndex !== -1) {
              return <Cocktail key={item.id} {...item} favorite={true} />;
            }
          }
          return <Cocktail key={item.id} {...item} favorite={false} />;
        })}
      </div>
    </div>
  );
};
{
  /* <div className="cocktailList">
  <h1 className="title">Cocktails</h1>
  <div className="cocktails">
    {tempCocktails.map((item) => {
      return <Cocktail key={item.id} {...item} />;
    })}
  </div>
</div>; */
}

// tempCocktails.map((item, i) => {
//   const favorites = getLocalStorage();
//   const object = item;
//   if (favorites.length > 0) {
//     const index = favorites.findIndex((item) => {
//       return item.id === object.id;
//     });
//     return <Cocktail key={item.id} {...item} favorite={true} />;
//   }
//   return <Cocktail key={item.id} {...item} favorite={false} />;
// });

export default CocktailList;
